<div class="progress" [style.width]="progressWidth">
</div>